import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'nmo-simple-footer',
    templateUrl: './simple-footer.component.html',
    styleUrls: ['./simple-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SimpleFooterComponent {
  constructor() {}
}
